import * as api from '../api';
import { SNACKBAR_DURATION_MS, getSnackbarColor } from "../utils/snackbar";

// Action Types
export const GET_DOCUMENT_TEMPLATES = 'GET_DOCUMENT_TEMPLATES';
export const GET_DOCUMENT_TEMPLATE = 'GET_DOCUMENT_TEMPLATE';
export const CREATE_DOCUMENT_TEMPLATE = 'CREATE_DOCUMENT_TEMPLATE';
export const UPDATE_DOCUMENT_TEMPLATE = 'UPDATE_DOCUMENT_TEMPLATE';
export const DELETE_DOCUMENT_TEMPLATE = 'DELETE_DOCUMENT_TEMPLATE';
export const DUPLICATE_DOCUMENT_TEMPLATE = 'DUPLICATE_DOCUMENT_TEMPLATE';

// Get all templates
export const getDocumentTemplates = (filters) => async (dispatch) => {
  try {
    const { data } = await api.fetchDocumentTemplates(filters);

    dispatch({
      type: GET_DOCUMENT_TEMPLATES,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error fetching document templates:', error);
    throw error;
  }
};

// Get single template
export const getDocumentTemplate = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchDocumentTemplate(id);

    dispatch({
      type: GET_DOCUMENT_TEMPLATE,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error fetching document template:', error);
    throw error;
  }
};

// Create template
export const createDocumentTemplate = (templateData, openSnackbar) => async (dispatch) => {
  try {
    console.log('=== createDocumentTemplate ACTION START ===');
    console.log('Creating template with data:', templateData);
    
    const { data } = await api.createDocumentTemplate(templateData);
    
    console.log('Template created successfully, response:', data);

    dispatch({
      type: CREATE_DOCUMENT_TEMPLATE,
      payload: data
    });

    if (openSnackbar) {
      openSnackbar('Template created successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Template created successfully"));
    }

    console.log('=== createDocumentTemplate ACTION END (SUCCESS) ===');
    return data;
  } catch (error) {
    console.error('=== createDocumentTemplate ACTION ERROR ===');
    console.error('Error creating template:', error);
    console.error('Error response:', error.response);
    console.error('Error status:', error.response?.status);
    console.error('Error data:', error.response?.data);
    console.error('Error message:', error.message);
    
    if (openSnackbar) {
      const errorMessage = error.response?.data?.message || 'Error creating template';
      console.log('Showing error snackbar:', errorMessage);
      openSnackbar(errorMessage, SNACKBAR_DURATION_MS, getSnackbarColor("errorMessage"));
    }
    
    console.log('=== createDocumentTemplate ACTION END (ERROR) ===');
    throw error;
  }
};

// Update template
export const updateDocumentTemplate = (id, templateData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateDocumentTemplate(id, templateData);

    dispatch({
      type: UPDATE_DOCUMENT_TEMPLATE,
      payload: data
    });

    openSnackbar('Template updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Template updated successfully"));

    return data;
  } catch (error) {
    console.error('Error updating template:', error);
    openSnackbar('Error updating template', SNACKBAR_DURATION_MS, getSnackbarColor("Error updating template"));
    throw error;
  }
};

// Delete template
export const deleteDocumentTemplate = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteDocumentTemplate(id);

    dispatch({
      type: DELETE_DOCUMENT_TEMPLATE,
      payload: id
    });

    openSnackbar('Template deleted successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Template deleted successfully"));
  } catch (error) {
    console.error('Error deleting template:', error);
    openSnackbar('Error deleting template', SNACKBAR_DURATION_MS, getSnackbarColor("Error deleting template"));
    throw error;
  }
};

// Duplicate template
export const duplicateDocumentTemplate = (id, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.duplicateDocumentTemplate(id);

    dispatch({
      type: CREATE_DOCUMENT_TEMPLATE,
      payload: data
    });

    openSnackbar('Template duplicated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Template duplicated successfully"));

    return data;
  } catch (error) {
    console.error('Error duplicating template:', error);
    openSnackbar('Error duplicating template', SNACKBAR_DURATION_MS, getSnackbarColor("Error duplicating template"));
    throw error;
  }
};

// Generate document from template
export const generateDocumentFromTemplate = async (templateId, data) => {
  try {
    const response = await api.generateDocumentFromTemplate(templateId, data);
    return response.data;
  } catch (error) {
    console.error('Error generating document from template:', error);
    throw error;
  }
};
